import { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select from '__components/Inputs/Select';
import Cols from '__components/Layout/Cols';
import { grayScale } from '__app/colors';
import { StyledModelMessage } from './styles';
import { LLMErrors, ModelOption, ProviderOption } from './types';
import { useFlashTransition } from '__hooks/useFlashState';

type LLMProviderSelectProps = {
  value: ModelOption | undefined;
  options: ProviderOption[];
  onChange: (model: ModelOption) => void;
  errors: LLMErrors;
  disabled: boolean;
};

export const LLMProviderSelect: FC<LLMProviderSelectProps> = ({
  value,
  options,
  onChange,
  errors,
  disabled,
}) => {
  const { t } = useTranslation();

  const [message, showMessage, flashVariableMessage] = useFlashTransition();

  useEffect(() => {
    if (errors.provider?.hasError) {
      flashVariableMessage(errors.provider.message);
    }
  }, [flashVariableMessage, errors.provider]);

  const validate = useMemo(
    () => ({ message, showMessage }),
    [message, showMessage]
  );

  return (
    <>
      <Cols columns={3} gutter="20px">
        <Select
          label={t('Choose Model')}
          placeholder={t('Choose Model')}
          value={value}
          options={options}
          onChange={onChange}
          menuInline
          validate={validate}
          error={errors.provider?.hasError}
          disabled={disabled}
        />
      </Cols>
      <StyledModelMessage fontStyle="italic" color={grayScale.mediumDark}>
        {t(`Enable more providers to have access to more models`)}
      </StyledModelMessage>
    </>
  );
};
